/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  AddMemberRequest,
  ApiEnvelopeBoolean,
  ApiEnvelopeTenantDto,
  ApiEnvelopeTenantListResponse,
  ApiEnvelopeTenantMemberDto,
  ApiEnvelopeTenantMembersResponse,
  ApiEnvelopeTenantSettingsDto,
  CreateTenantRequest,
  TenantSettingsRequest,
  UpdateMemberRoleRequest,
  UpdateTenantRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type tenantAdminGetAllTenantsResponse200 = {
  data: ApiEnvelopeTenantListResponse
  status: 200
}

export type tenantAdminGetAllTenantsResponse401 = {
  data: ApiEnvelopeTenantListResponse
  status: 401
}

export type tenantAdminGetAllTenantsResponse403 = {
  data: ApiEnvelopeTenantListResponse
  status: 403
}

export type tenantAdminGetAllTenantsResponseSuccess = (tenantAdminGetAllTenantsResponse200) & {
  headers: Headers;
};
export type tenantAdminGetAllTenantsResponseError = (tenantAdminGetAllTenantsResponse401 | tenantAdminGetAllTenantsResponse403) & {
  headers: Headers;
};

export type tenantAdminGetAllTenantsResponse = (tenantAdminGetAllTenantsResponseSuccess | tenantAdminGetAllTenantsResponseError)

export const getTenantAdminGetAllTenantsUrl = () => {




  return `/api/admin/tenants`
}

export const useTenantAdminGetAllTenantsHook = (): ( options?: RequestInit) => Promise<tenantAdminGetAllTenantsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getTenantAdminGetAllTenantsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type tenantAdminCreateTenantResponse200 = {
  data: ApiEnvelopeTenantDto
  status: 200
}

export type tenantAdminCreateTenantResponse400 = {
  data: ApiEnvelopeTenantDto
  status: 400
}

export type tenantAdminCreateTenantResponse401 = {
  data: ApiEnvelopeTenantDto
  status: 401
}

export type tenantAdminCreateTenantResponse403 = {
  data: ApiEnvelopeTenantDto
  status: 403
}

export type tenantAdminCreateTenantResponseSuccess = (tenantAdminCreateTenantResponse200) & {
  headers: Headers;
};
export type tenantAdminCreateTenantResponseError = (tenantAdminCreateTenantResponse400 | tenantAdminCreateTenantResponse401 | tenantAdminCreateTenantResponse403) & {
  headers: Headers;
};

export type tenantAdminCreateTenantResponse = (tenantAdminCreateTenantResponseSuccess | tenantAdminCreateTenantResponseError)

export const getTenantAdminCreateTenantUrl = () => {




  return `/api/admin/tenants`
}

export const useTenantAdminCreateTenantHook = (): (createTenantRequest?: CreateTenantRequest, options?: RequestInit) => Promise<tenantAdminCreateTenantResponse> => {

      const customFetcher = useSfetchMutator();
      return (createTenantRequest?: CreateTenantRequest, options?: RequestInit) => {

        return customFetcher(getTenantAdminCreateTenantUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTenantRequest)
  }
);
      }
  }


export type tenantAdminGetTenantResponse200 = {
  data: ApiEnvelopeTenantDto
  status: 200
}

export type tenantAdminGetTenantResponse401 = {
  data: ApiEnvelopeTenantDto
  status: 401
}

export type tenantAdminGetTenantResponse403 = {
  data: ApiEnvelopeTenantDto
  status: 403
}

export type tenantAdminGetTenantResponse404 = {
  data: ApiEnvelopeTenantDto
  status: 404
}

export type tenantAdminGetTenantResponseSuccess = (tenantAdminGetTenantResponse200) & {
  headers: Headers;
};
export type tenantAdminGetTenantResponseError = (tenantAdminGetTenantResponse401 | tenantAdminGetTenantResponse403 | tenantAdminGetTenantResponse404) & {
  headers: Headers;
};

export type tenantAdminGetTenantResponse = (tenantAdminGetTenantResponseSuccess | tenantAdminGetTenantResponseError)

export const getTenantAdminGetTenantUrl = (tenantId: string,) => {




  return `/api/admin/tenants/${tenantId}`
}

export const useTenantAdminGetTenantHook = (): (tenantId: string, options?: RequestInit) => Promise<tenantAdminGetTenantResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string, options?: RequestInit) => {

        return customFetcher(getTenantAdminGetTenantUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type tenantAdminUpdateTenantResponse200 = {
  data: ApiEnvelopeTenantDto
  status: 200
}

export type tenantAdminUpdateTenantResponse400 = {
  data: ApiEnvelopeTenantDto
  status: 400
}

export type tenantAdminUpdateTenantResponse401 = {
  data: ApiEnvelopeTenantDto
  status: 401
}

export type tenantAdminUpdateTenantResponse403 = {
  data: ApiEnvelopeTenantDto
  status: 403
}

export type tenantAdminUpdateTenantResponse404 = {
  data: ApiEnvelopeTenantDto
  status: 404
}

export type tenantAdminUpdateTenantResponseSuccess = (tenantAdminUpdateTenantResponse200) & {
  headers: Headers;
};
export type tenantAdminUpdateTenantResponseError = (tenantAdminUpdateTenantResponse400 | tenantAdminUpdateTenantResponse401 | tenantAdminUpdateTenantResponse403 | tenantAdminUpdateTenantResponse404) & {
  headers: Headers;
};

export type tenantAdminUpdateTenantResponse = (tenantAdminUpdateTenantResponseSuccess | tenantAdminUpdateTenantResponseError)

export const getTenantAdminUpdateTenantUrl = (tenantId: string,) => {




  return `/api/admin/tenants/${tenantId}`
}

export const useTenantAdminUpdateTenantHook = (): (tenantId: string,
    updateTenantRequest?: UpdateTenantRequest, options?: RequestInit) => Promise<tenantAdminUpdateTenantResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string,
    updateTenantRequest?: UpdateTenantRequest, options?: RequestInit) => {

        return customFetcher(getTenantAdminUpdateTenantUrl(tenantId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTenantRequest)
  }
);
      }
  }


export type tenantAdminDeleteTenantResponse200 = {
  data: ApiEnvelopeBoolean
  status: 200
}

export type tenantAdminDeleteTenantResponse400 = {
  data: ApiEnvelopeBoolean
  status: 400
}

export type tenantAdminDeleteTenantResponse401 = {
  data: ApiEnvelopeBoolean
  status: 401
}

export type tenantAdminDeleteTenantResponse403 = {
  data: ApiEnvelopeBoolean
  status: 403
}

export type tenantAdminDeleteTenantResponse404 = {
  data: ApiEnvelopeBoolean
  status: 404
}

export type tenantAdminDeleteTenantResponseSuccess = (tenantAdminDeleteTenantResponse200) & {
  headers: Headers;
};
export type tenantAdminDeleteTenantResponseError = (tenantAdminDeleteTenantResponse400 | tenantAdminDeleteTenantResponse401 | tenantAdminDeleteTenantResponse403 | tenantAdminDeleteTenantResponse404) & {
  headers: Headers;
};

export type tenantAdminDeleteTenantResponse = (tenantAdminDeleteTenantResponseSuccess | tenantAdminDeleteTenantResponseError)

export const getTenantAdminDeleteTenantUrl = (tenantId: string,) => {




  return `/api/admin/tenants/${tenantId}`
}

export const useTenantAdminDeleteTenantHook = (): (tenantId: string, options?: RequestInit) => Promise<tenantAdminDeleteTenantResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string, options?: RequestInit) => {

        return customFetcher(getTenantAdminDeleteTenantUrl(tenantId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type tenantAdminGetTenantSettingsResponse200 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 200
}

export type tenantAdminGetTenantSettingsResponse401 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 401
}

export type tenantAdminGetTenantSettingsResponse403 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 403
}

export type tenantAdminGetTenantSettingsResponse404 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 404
}

export type tenantAdminGetTenantSettingsResponseSuccess = (tenantAdminGetTenantSettingsResponse200) & {
  headers: Headers;
};
export type tenantAdminGetTenantSettingsResponseError = (tenantAdminGetTenantSettingsResponse401 | tenantAdminGetTenantSettingsResponse403 | tenantAdminGetTenantSettingsResponse404) & {
  headers: Headers;
};

export type tenantAdminGetTenantSettingsResponse = (tenantAdminGetTenantSettingsResponseSuccess | tenantAdminGetTenantSettingsResponseError)

export const getTenantAdminGetTenantSettingsUrl = (tenantId: string,) => {




  return `/api/admin/tenants/${tenantId}/settings`
}

export const useTenantAdminGetTenantSettingsHook = (): (tenantId: string, options?: RequestInit) => Promise<tenantAdminGetTenantSettingsResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string, options?: RequestInit) => {

        return customFetcher(getTenantAdminGetTenantSettingsUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type tenantAdminUpdateTenantSettingsResponse200 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 200
}

export type tenantAdminUpdateTenantSettingsResponse400 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 400
}

export type tenantAdminUpdateTenantSettingsResponse401 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 401
}

export type tenantAdminUpdateTenantSettingsResponse403 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 403
}

export type tenantAdminUpdateTenantSettingsResponse404 = {
  data: ApiEnvelopeTenantSettingsDto
  status: 404
}

export type tenantAdminUpdateTenantSettingsResponseSuccess = (tenantAdminUpdateTenantSettingsResponse200) & {
  headers: Headers;
};
export type tenantAdminUpdateTenantSettingsResponseError = (tenantAdminUpdateTenantSettingsResponse400 | tenantAdminUpdateTenantSettingsResponse401 | tenantAdminUpdateTenantSettingsResponse403 | tenantAdminUpdateTenantSettingsResponse404) & {
  headers: Headers;
};

export type tenantAdminUpdateTenantSettingsResponse = (tenantAdminUpdateTenantSettingsResponseSuccess | tenantAdminUpdateTenantSettingsResponseError)

export const getTenantAdminUpdateTenantSettingsUrl = (tenantId: string,) => {




  return `/api/admin/tenants/${tenantId}/settings`
}

export const useTenantAdminUpdateTenantSettingsHook = (): (tenantId: string,
    tenantSettingsRequest?: TenantSettingsRequest, options?: RequestInit) => Promise<tenantAdminUpdateTenantSettingsResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string,
    tenantSettingsRequest?: TenantSettingsRequest, options?: RequestInit) => {

        return customFetcher(getTenantAdminUpdateTenantSettingsUrl(tenantId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tenantSettingsRequest)
  }
);
      }
  }


export type tenantAdminGetMembersResponse200 = {
  data: ApiEnvelopeTenantMembersResponse
  status: 200
}

export type tenantAdminGetMembersResponse401 = {
  data: ApiEnvelopeTenantMembersResponse
  status: 401
}

export type tenantAdminGetMembersResponse403 = {
  data: ApiEnvelopeTenantMembersResponse
  status: 403
}

export type tenantAdminGetMembersResponse404 = {
  data: ApiEnvelopeTenantMembersResponse
  status: 404
}

export type tenantAdminGetMembersResponseSuccess = (tenantAdminGetMembersResponse200) & {
  headers: Headers;
};
export type tenantAdminGetMembersResponseError = (tenantAdminGetMembersResponse401 | tenantAdminGetMembersResponse403 | tenantAdminGetMembersResponse404) & {
  headers: Headers;
};

export type tenantAdminGetMembersResponse = (tenantAdminGetMembersResponseSuccess | tenantAdminGetMembersResponseError)

export const getTenantAdminGetMembersUrl = (tenantId: string,) => {




  return `/api/admin/tenants/${tenantId}/members`
}

export const useTenantAdminGetMembersHook = (): (tenantId: string, options?: RequestInit) => Promise<tenantAdminGetMembersResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string, options?: RequestInit) => {

        return customFetcher(getTenantAdminGetMembersUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type tenantAdminAddMemberResponse200 = {
  data: ApiEnvelopeTenantMemberDto
  status: 200
}

export type tenantAdminAddMemberResponse400 = {
  data: ApiEnvelopeTenantMemberDto
  status: 400
}

export type tenantAdminAddMemberResponse401 = {
  data: ApiEnvelopeTenantMemberDto
  status: 401
}

export type tenantAdminAddMemberResponse403 = {
  data: ApiEnvelopeTenantMemberDto
  status: 403
}

export type tenantAdminAddMemberResponseSuccess = (tenantAdminAddMemberResponse200) & {
  headers: Headers;
};
export type tenantAdminAddMemberResponseError = (tenantAdminAddMemberResponse400 | tenantAdminAddMemberResponse401 | tenantAdminAddMemberResponse403) & {
  headers: Headers;
};

export type tenantAdminAddMemberResponse = (tenantAdminAddMemberResponseSuccess | tenantAdminAddMemberResponseError)

export const getTenantAdminAddMemberUrl = (tenantId: string,) => {




  return `/api/admin/tenants/${tenantId}/members`
}

export const useTenantAdminAddMemberHook = (): (tenantId: string,
    addMemberRequest?: AddMemberRequest, options?: RequestInit) => Promise<tenantAdminAddMemberResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string,
    addMemberRequest?: AddMemberRequest, options?: RequestInit) => {

        return customFetcher(getTenantAdminAddMemberUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addMemberRequest)
  }
);
      }
  }


export type tenantAdminRemoveMemberResponse200 = {
  data: ApiEnvelopeBoolean
  status: 200
}

export type tenantAdminRemoveMemberResponse400 = {
  data: ApiEnvelopeBoolean
  status: 400
}

export type tenantAdminRemoveMemberResponse401 = {
  data: ApiEnvelopeBoolean
  status: 401
}

export type tenantAdminRemoveMemberResponse403 = {
  data: ApiEnvelopeBoolean
  status: 403
}

export type tenantAdminRemoveMemberResponseSuccess = (tenantAdminRemoveMemberResponse200) & {
  headers: Headers;
};
export type tenantAdminRemoveMemberResponseError = (tenantAdminRemoveMemberResponse400 | tenantAdminRemoveMemberResponse401 | tenantAdminRemoveMemberResponse403) & {
  headers: Headers;
};

export type tenantAdminRemoveMemberResponse = (tenantAdminRemoveMemberResponseSuccess | tenantAdminRemoveMemberResponseError)

export const getTenantAdminRemoveMemberUrl = (tenantId: string,
    userId: string,) => {




  return `/api/admin/tenants/${tenantId}/members/${userId}`
}

export const useTenantAdminRemoveMemberHook = (): (tenantId: string,
    userId: string, options?: RequestInit) => Promise<tenantAdminRemoveMemberResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string,
    userId: string, options?: RequestInit) => {

        return customFetcher(getTenantAdminRemoveMemberUrl(tenantId,userId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type tenantAdminUpdateMemberRoleResponse200 = {
  data: ApiEnvelopeTenantMemberDto
  status: 200
}

export type tenantAdminUpdateMemberRoleResponse400 = {
  data: ApiEnvelopeTenantMemberDto
  status: 400
}

export type tenantAdminUpdateMemberRoleResponse401 = {
  data: ApiEnvelopeTenantMemberDto
  status: 401
}

export type tenantAdminUpdateMemberRoleResponse403 = {
  data: ApiEnvelopeTenantMemberDto
  status: 403
}

export type tenantAdminUpdateMemberRoleResponseSuccess = (tenantAdminUpdateMemberRoleResponse200) & {
  headers: Headers;
};
export type tenantAdminUpdateMemberRoleResponseError = (tenantAdminUpdateMemberRoleResponse400 | tenantAdminUpdateMemberRoleResponse401 | tenantAdminUpdateMemberRoleResponse403) & {
  headers: Headers;
};

export type tenantAdminUpdateMemberRoleResponse = (tenantAdminUpdateMemberRoleResponseSuccess | tenantAdminUpdateMemberRoleResponseError)

export const getTenantAdminUpdateMemberRoleUrl = (tenantId: string,
    userId: string,) => {




  return `/api/admin/tenants/${tenantId}/members/${userId}`
}

export const useTenantAdminUpdateMemberRoleHook = (): (tenantId: string,
    userId: string,
    updateMemberRoleRequest?: UpdateMemberRoleRequest, options?: RequestInit) => Promise<tenantAdminUpdateMemberRoleResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string,
    userId: string,
    updateMemberRoleRequest?: UpdateMemberRoleRequest, options?: RequestInit) => {

        return customFetcher(getTenantAdminUpdateMemberRoleUrl(tenantId,userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateMemberRoleRequest)
  }
);
      }
  }


